// ===================================
// KAIXO - Lista canónica de intereses/sectores
// Compartido entre User.interests y ChannelV2.targetInterests / category
// ===================================

export const INTERESTS = [
    'food', 'tech', 'fashion', 'sports', 'travel', 'art', 'music',
    'education', 'health', 'business', 'entertainment', 'news',
    'photography', 'games', 'science', 'nature', 'fitness',
    'automotive', 'home', 'finance', 'beauty', 'pets', 'cooking',
    'books', 'movies', 'other'
];

export const INTEREST_LABELS_ES = {
    food: '🍔 Comida',
    tech: '💻 Tecnología',
    fashion: '👗 Moda',
    sports: '⚽ Deportes',
    travel: '✈️ Viajes',
    art: '🎨 Arte',
    music: '🎵 Música',
    education: '📚 Educación',
    health: '🏥 Salud',
    business: '💼 Negocios',
    entertainment: '🎭 Entretenimiento',
    news: '📰 Noticias',
    photography: '📷 Fotografía',
    games: '🎮 Videojuegos',
    science: '🔬 Ciencia',
    nature: '🌿 Naturaleza',
    fitness: '💪 Fitness',
    automotive: '🚗 Automotriz',
    home: '🏠 Hogar',
    finance: '💰 Finanzas',
    beauty: '💄 Belleza',
    pets: '🐾 Mascotas',
    cooking: '👨‍🍳 Cocina',
    books: '📖 Libros',
    movies: '🎬 Cine',
    other: '🌟 Otros'
};

export const INTEREST_LABELS_EN = {
    food: '🍔 Food',
    tech: '💻 Tech',
    fashion: '👗 Fashion',
    sports: '⚽ Sports',
    travel: '✈️ Travel',
    art: '🎨 Art',
    music: '🎵 Music',
    education: '📚 Education',
    health: '🏥 Health',
    business: '💼 Business',
    entertainment: '🎭 Entertainment',
    news: '📰 News',
    photography: '📷 Photography',
    games: '🎮 Games',
    science: '🔬 Science',
    nature: '🌿 Nature',
    fitness: '💪 Fitness',
    automotive: '🚗 Automotive',
    home: '🏠 Home',
    finance: '💰 Finance',
    beauty: '💄 Beauty',
    pets: '🐾 Pets',
    cooking: '👨‍🍳 Cooking',
    books: '📖 Books',
    movies: '🎬 Movies',
    other: '🌟 Other'
};

export function getInterestLabel(key, language = 'español') {
    const dict = language === 'inglés' ? INTEREST_LABELS_EN : INTEREST_LABELS_ES;
    return dict[key] || key;
}
